import { render, staticRenderFns } from "./NtRecord.vue?vue&type=template&id=526b44f0&lang=pug&"
import script from "./NtRecord.vue?vue&type=script&lang=js&"
export * from "./NtRecord.vue?vue&type=script&lang=js&"
import style0 from "./NtRecord.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports